import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  index(activityId, currentPage, perPage, status) {
    return httpAdminClient.get(`/admin/train/activities/${activityId}/entries`, {
      params: {
        state: status,
        page: currentPage,
        per_page: perPage,
      },
    });
  },
  patch(entryId, data) {
    return httpAdminClient.put(`/admin/train/entries/${entryId}`, { train_entry: { ...data } });
  },
  apply(id) {
    return httpAdminClient.post(`/admin/train/entries/${id}/apply`);
  },
  cancel(id) {
    return httpAdminClient.post(`/admin/train/entries/${id}/cancel`);
  },
  homeworks(entryId, currentPage, perPage) {
    return httpAdminClient.get(`/admin/train/entries/${entryId}/homeworks'`, {
      params: {
        page: currentPage,
        per_page: perPage,
      },
    });
  },
  logs(trainId, userId, currentPage, perPage) {
    return httpAdminClient.get(`/admin/train/activities/${trainId}/logs`, {
      params: {
        user_id: userId,
        page: currentPage,
        per_page: perPage,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/train/api-entry.js